import { useProject } from '../../project-hooks/useProject';
import { useState } from 'react';
import { VippsPaymentForm } from '../project-support-buttons/vipps-payment-form/VippsPaymentForm';
import { useVippsLightningFastPayment } from '../../../components/button/vipps-button/useVippsLightningFastPayment';
import { ProjectSupportButtonsActive } from '../project-support-buttons/project-support-buttons-active/ProjectSupportButtonsActive';
import styles from './ProjectInfoBox.module.less';

export const ProjectInfoBoxSupport = ({ projectShareModalRef }) => {
    const project = useProject();
    const { shouldShowLightningFastVippsPaymentButton } = useVippsLightningFastPayment({
        project,
    });
    const [hideFloatingSupportButtonsOnMobile, setHideFloatingSupportButtonsOnMobile] = useState(true);
    return (
        <>
            {shouldShowLightningFastVippsPaymentButton && (
                <VippsPaymentForm
                    project={project}
                    onVisibilityChange={setHideFloatingSupportButtonsOnMobile}
                    projectShareModalRef={projectShareModalRef}
                />
            )}
            <ProjectSupportButtonsActive
                className={[
                    shouldShowLightningFastVippsPaymentButton ? styles.supportButtonsVippsActive : '',
                    hideFloatingSupportButtonsOnMobile ? styles.animatedHideSupportButtons : '',
                ].join(' ')}
                projectShareModalRef={projectShareModalRef}
            />
        </>
    );
};
